export const CART_ACTION_TYPES = {
  TOGGLE_SHOW_CART: "cart/[SHOW_CART] toggled",
  SET_CART_ITEMS: "cart/[CART_ITEMS] updated",
};
